import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IBillabilityRow, ITrendPoint, ITrendGroupPoint, IBillabilityQuery, DEFAULT_BILLABILITY_QUERY } from "models/billability"
import { DepartmentLevel } from "models/department-level"
import { BillabilityReportRecipient } from "models/billability-report-recipient"
import EmployeeClass from "models/employee-class"
import Branch from "models/branch"
import Department from "models/department"

export interface BillabilitySliceState {
    reportRecipients: BillabilityReportRecipient[]
    query: IBillabilityQuery
    rows: IBillabilityRow[]
    trend: ITrendPoint[]
    trendByGroup: ITrendGroupPoint[]
    employeeClass: EmployeeClass[]
    branches: Branch[]
    departments: Department[]
    departmentLevels: DepartmentLevel[]
}

const initialState: BillabilitySliceState = {
    reportRecipients: [],
    query: DEFAULT_BILLABILITY_QUERY,
    rows: [],
    trend: [],
    trendByGroup: [],
    employeeClass: [],
    branches: [],
    departments: [],
    departmentLevels: [],
}

const billabilitySlice = createSlice({
    name: 'billability',
    initialState,
    reducers: {
        setReportRecipients(state, { payload }: PayloadAction<BillabilityReportRecipient[]>) {
            state.reportRecipients = payload
        },
        addReportRecipient(state, { payload }: PayloadAction<BillabilityReportRecipient>) {
            state.reportRecipients = [...state.reportRecipients, payload]
        },
        setReportRecipient(state, { payload }: PayloadAction<BillabilityReportRecipient>) {
            state.reportRecipients = state.reportRecipients.map(r => r.id === payload.id ? payload : r)
        },
        removeReportRecipient(state, { payload: id }: PayloadAction<string>) {
            state.reportRecipients = state.reportRecipients.filter(r => r.id !== id)
        },
        setBillabilityQuery(state, { payload }: PayloadAction<IBillabilityQuery>) {
            state.query = payload
        },
        setRows(state, { payload }: PayloadAction<IBillabilityRow[]>) {
            state.rows = payload
        },
        setTrend(state, { payload }: PayloadAction<ITrendPoint[]>) {
            state.trend = payload
        },
        setTrendByGroup(state, { payload }: PayloadAction<ITrendGroupPoint[]>) {
            state.trendByGroup = payload
        },
        setBillabilitySearchFields(state, { payload }: PayloadAction<{
            employeeClass: EmployeeClass[]
            branches: Branch[]
            departments: Department[]
            departmentLevels: DepartmentLevel[]
        }>) {
            state.employeeClass = payload.employeeClass
            state.branches = payload.branches
            state.departments = payload.departments
            state.departmentLevels = payload.departmentLevels ?? []
        }
    }
})

export const {
    setBillabilityQuery,
    setReportRecipients,
    addReportRecipient,
    setReportRecipient,
    removeReportRecipient,
    setRows,
    setTrend,
    setTrendByGroup,
    setBillabilitySearchFields,
} = billabilitySlice.actions
export default billabilitySlice.reducer
